/* cc-qr.js - 17 October 2026
   A QR code, generated here, because the alternatives are worse.

   Charly, 17 Oct: the AR button must appear on DESKTOP too and invite
   someone to scan a code and carry on with it on their phone. That is a
   better answer than the button being absent, which is what it was: a
   desktop visitor now gets a door rather than nothing.

   WHY NOT AN IMAGE SERVICE. The obvious route is a QR image URL from some
   api.qrserver or chart endpoint. That is a third-party origin on the page,
   which this site has a recorded decision against and which would also hand
   a log of every product someone looked at to a stranger. A QR code is a
   pure function of a string; there is no reason to ask anyone for one.

   WHY NOT A LIBRARY. Same origin problem if loaded, and vendoring a few
   hundred lines of someone else's minified code into a live store to draw a
   square of dots is not better than the few hundred lines below, which can
   at least be read.

   SCOPE, chosen to remove whole classes of bug rather than to be clever:
     - byte mode only, which is what a URL is
     - error correction level L, which is right for a screen: a QR read off
       a bright display at 30cm has none of the damage L is weak against
     - versions 1 to 7 only

   That last one is the important simplification. Every version to 7 is a
   SINGLE BLOCK at level L, so there is no block interleaving, which is
   where hand-written encoders usually go wrong. Version 7 does need the
   version information area and a grid of alignment patterns rather than
   one, and both are here.

   The cap was 5 until the builder needed it raised: a set carries its
   photographs, sizes, frame and room in the address, which runs past 130
   characters on a draft. v7-L holds 154. Anything longer is refused rather
   than mis-encoded, and the caller renders nothing instead.

   VERIFIED BY DECODING, not by eye: scripts/check-qr.js draws these in a
   real browser and reads them back with the platform's own BarcodeDetector,
   which is the only check that means anything for a barcode. */
(function () {
  'use strict';

  /* total codewords, data codewords, at level L, one block each */
  var VERSIONS = [
    null,
    { size: 21, total: 26,  data: 19,  align: null,     blocks: 1 },
    { size: 25, total: 44,  data: 34,  align: [6, 18],  blocks: 1 },
    { size: 29, total: 70,  data: 55,  align: [6, 22],  blocks: 1 },
    { size: 33, total: 100, data: 80,  align: [6, 26],  blocks: 1 },
    { size: 37, total: 134, data: 108, align: [6, 30], blocks: 1 },
    { size: 41, total: 172, data: 136, align: [6, 34], blocks: 2 },
    { size: 45, total: 196, data: 156, align: [6, 22, 38], blocks: 2 },
  ];

  /* ---------------------------------------------------------- GF(256) */

  var EXP = new Uint8Array(512), LOG = new Uint8Array(256);
  (function () {
    var x = 1;
    for (var i = 0; i < 255; i++) {
      EXP[i] = x; LOG[x] = i;
      x <<= 1;
      if (x & 0x100) x ^= 0x11D;   /* the QR primitive polynomial */
    }
    for (var j = 255; j < 512; j++) EXP[j] = EXP[j - 255];
  }());
  function mul(a, b) { return (a === 0 || b === 0) ? 0 : EXP[LOG[a] + LOG[b]]; }

  function rsGenerator(n) {
    var poly = [1];
    for (var i = 0; i < n; i++) {
      var next = new Array(poly.length + 1).fill(0);
      /* poly[0] is the HIGHEST degree coefficient. Multiplying by
         (x + a^i): the x term keeps a coefficient's index, and the a^i term
         pushes it one lower in degree, which is one HIGHER in index. The
         first version had these two swapped, which left gen[0] equal to a^i
         instead of 1. A non-monic generator makes the synthetic division
         below meaningless, so every error correction codeword was wrong
         while the data codewords were perfect. The code drew beautifully
         and no reader on earth could read it. */
      for (var j = 0; j < poly.length; j++) {
        next[j] ^= poly[j];
        next[j + 1] ^= mul(poly[j], EXP[i]);
      }
      poly = next;
    }
    return poly;
  }

  function rsEncode(data, ecLen) {
    var gen = rsGenerator(ecLen);
    var res = new Uint8Array(data.length + ecLen);
    res.set(data, 0);
    for (var i = 0; i < data.length; i++) {
      var factor = res[i];
      if (!factor) continue;
      for (var j = 0; j < gen.length; j++) res[i + j] ^= mul(gen[j], factor);
    }
    return res.slice(data.length);
  }

  /* ------------------------------------------------------------ data */

  function encodeBytes(text, version) {
    var bytes = new TextEncoder().encode(text);
    var v = VERSIONS[version];
    var bits = [];
    function push(value, len) { for (var i = len - 1; i >= 0; i--) bits.push((value >> i) & 1); }

    push(4, 4);                 /* byte mode */
    push(bytes.length, 8);      /* 8-bit count indicator, versions 1 to 9 */
    for (var i = 0; i < bytes.length; i++) push(bytes[i], 8);

    var capacity = v.data * 8;
    for (var t = 0; t < 4 && bits.length < capacity; t++) bits.push(0);  /* terminator */
    while (bits.length % 8) bits.push(0);

    var out = new Uint8Array(v.data);
    for (var b = 0; b < bits.length; b += 8) {
      var byte = 0;
      for (var k = 0; k < 8; k++) byte = (byte << 1) | bits[b + k];
      out[b / 8] = byte;
    }
    /* the two alternating pad codewords the specification names */
    var pads = [0xEC, 0x11], p = 0;
    for (var f = bits.length / 8; f < v.data; f++) out[f] = pads[p++ % 2];
    return out;
  }

  /* INTERLEAVING. Versions 1 to 5 at level L are a single block and the
     codewords simply follow the data. From version 6 they are TWO blocks,
     and the stream is interleaved: the first codeword of every block, then
     the second of every block, and so on, then the same for the error
     correction. Writing them back to back instead produces a code that is
     structurally perfect and reads as nothing, which is exactly what
     happened the first time versions 6 and 7 were added here.

     Every version to 7 has equal-sized blocks at this level, so there is no
     short-block case to handle. That is the reason the cap is 7 rather than
     higher: beyond it the blocks differ in length and this would need the
     group arithmetic as well. */
  function codewords(text, version) {
    var info = VERSIONS[version];
    var data = encodeBytes(text, version);
    var nb = info.blocks;
    var perData = info.data / nb;
    var perEc = (info.total - info.data) / nb;

    var dataBlocks = [], ecBlocks = [], b;
    for (b = 0; b < nb; b++) {
      var chunk = data.slice(b * perData, (b + 1) * perData);
      dataBlocks.push(chunk);
      ecBlocks.push(rsEncode(chunk, perEc));
    }
    if (nb === 1) {
      var flat = new Uint8Array(info.total);
      flat.set(dataBlocks[0], 0);
      flat.set(ecBlocks[0], perData);
      return flat;
    }
    var out = new Uint8Array(info.total), p = 0, i;
    for (i = 0; i < perData; i++) for (b = 0; b < nb; b++) out[p++] = dataBlocks[b][i];
    for (i = 0; i < perEc; i++) for (b = 0; b < nb; b++) out[p++] = ecBlocks[b][i];
    return out;
  }

  /* ---------------------------------------------------------- matrix */

  function blank(size) {
    var m = [], r;
    for (r = 0; r < size; r++) m.push(new Array(size).fill(null));
    return m;
  }

  function placeFinder(m, row, col) {
    for (var r = -1; r <= 7; r++) {
      for (var c = -1; c <= 7; c++) {
        var rr = row + r, cc = col + c;
        if (rr < 0 || cc < 0 || rr >= m.length || cc >= m.length) continue;
        var on = (r >= 0 && r <= 6 && (c === 0 || c === 6))
              || (c >= 0 && c <= 6 && (r === 0 || r === 6))
              || (r >= 2 && r <= 4 && c >= 2 && c <= 4);
        m[rr][cc] = on ? 1 : 0;
      }
    }
  }

  /* The coordinates are a GRID, not one point. Versions 2 to 6 happen to
     reduce to a single pattern because the other three combinations sit
     under the finders, which is why the first version of this took a single
     centre and was right up to version 6 and wrong at 7. */
  function placeAlignment(m, coords) {
    var size = m.length, last = coords.length - 1;
    for (var a = 0; a < coords.length; a++) {
      for (var b = 0; b < coords.length; b++) {
        if ((a === 0 && b === 0) || (a === 0 && b === last) || (a === last && b === 0)) continue;
        var cr = coords[a], cc = coords[b];
        for (var r = -2; r <= 2; r++) {
          for (var c = -2; c <= 2; c++) {
            m[cr + r][cc + c] = (Math.max(Math.abs(r), Math.abs(c)) !== 1) ? 1 : 0;
          }
        }
      }
    }
  }

  /* BCH(18,6) version information, two 3x6 blocks, required from version 7.
     Absent on 1 to 6, which is why the cap used to sit at 5. */
  function placeVersion(m, version) {
    if (version < 7) return;
    var rem = version << 12;
    for (var i = 5; i >= 0; i--) {
      if (rem & (1 << (i + 12))) rem ^= 0x1F25 << i;
    }
    var bits = (version << 12) | rem;
    var size = m.length;
    for (var k = 0; k < 18; k++) {
      var bit = (bits >> k) & 1;
      var r = Math.floor(k / 3), c = k % 3;
      m[r][size - 11 + c] = bit;
      m[size - 11 + c][r] = bit;
    }
  }

  function reserveFormat(m) {
    var size = m.length, i;
    for (i = 0; i <= 8; i++) {
      if (m[8][i] === null) m[8][i] = 0;
      if (m[i][8] === null) m[i][8] = 0;
    }
    for (i = 0; i < 8; i++) {
      if (m[8][size - 1 - i] === null) m[8][size - 1 - i] = 0;
      if (m[size - 1 - i][8] === null) m[size - 1 - i][8] = 0;
    }
    m[size - 8][8] = 1;   /* the dark module, always set */
  }

  function skeleton(version) {
    var v = VERSIONS[version];
    var m = blank(v.size), i;
    placeFinder(m, 0, 0);
    placeFinder(m, 0, v.size - 7);
    placeFinder(m, v.size - 7, 0);
    if (v.align !== null) placeAlignment(m, v.align);
    placeVersion(m, version);
    for (i = 8; i < v.size - 8; i++) {      /* timing patterns */
      if (m[6][i] === null) m[6][i] = (i % 2 === 0) ? 1 : 0;
      if (m[i][6] === null) m[i][6] = (i % 2 === 0) ? 1 : 0;
    }
    reserveFormat(m);
    /* EXACTLY which modules are data, recorded while it is still knowable.
       The first version re-derived this with an isFunction(r, c) predicate
       that listed the finder, timing, format and alignment areas by
       arithmetic. Any disagreement between that predicate and what was
       actually reserved means the mask is applied to the wrong set of
       modules, and the result is a code that looks perfect and decodes to
       nothing. There is no reason to describe the reserved set twice when
       the skeleton already is it. */
    var free = [];
    for (var r2 = 0; r2 < v.size; r2++) {
      free.push(m[r2].map(function (cell) { return cell === null; }));
    }
    return { m: m, free: free };
  }

  /* the zigzag: two columns at a time, right to left, skipping column 6 */
  function placeData(m, codewords) {
    var size = m.length, bitIndex = 0, up = true;
    var total = codewords.length * 8;
    for (var right = size - 1; right > 0; right -= 2) {
      if (right === 6) right = 5;
      for (var step = 0; step < size; step++) {
        var row = up ? size - 1 - step : step;
        for (var k = 0; k < 2; k++) {
          var col = right - k;
          if (m[row][col] !== null) continue;
          var bit = 0;
          if (bitIndex < total) {
            bit = (codewords[bitIndex >> 3] >> (7 - (bitIndex & 7))) & 1;
            bitIndex++;
          }
          m[row][col] = bit;
        }
      }
      up = !up;
    }
  }

  var MASKS = [
    function (r, c) { return (r + c) % 2 === 0; },
    function (r) { return r % 2 === 0; },
    function (r, c) { return c % 3 === 0; },
    function (r, c) { return (r + c) % 3 === 0; },
    function (r, c) { return (Math.floor(r / 2) + Math.floor(c / 3)) % 2 === 0; },
    function (r, c) { return ((r * c) % 2) + ((r * c) % 3) === 0; },
    function (r, c) { return (((r * c) % 2) + ((r * c) % 3)) % 2 === 0; },
    function (r, c) { return (((r + c) % 2) + ((r * c) % 3)) % 2 === 0; },
  ];

  function applyMask(m, free, maskIndex) {
    var out = m.map(function (row) { return row.slice(); });
    for (var r = 0; r < out.length; r++) {
      for (var c = 0; c < out.length; c++) {
        if (!free[r][c]) continue;
        if (MASKS[maskIndex](r, c)) out[r][c] ^= 1;
      }
    }
    return out;
  }

  /* BCH(15,5) format information, level L is 01 */
  function formatBits(maskIndex) {
    var data = (0x01 << 3) | maskIndex;
    var rem = data << 10;
    for (var i = 4; i >= 0; i--) {
      if (rem & (1 << (i + 10))) rem ^= 0x537 << i;
    }
    return ((data << 10) | rem) ^ 0x5412;
  }

  function placeFormat(m, maskIndex) {
    /* BOTH COPIES ARE EASY TO TRANSPOSE AND THE FIRST VERSION OF THIS DID.
       The code scanned as correct, the finder patterns were right and the
       module count was right, and no reader could read it: every data
       module was being unmasked with the wrong mask because the mask index
       is carried HERE. Row and column are not interchangeable.

       First copy: bits 0 to 5 run DOWN column 8, then across row 8.
       Second copy: bits 0 to 7 run across row 8 from the right edge, then
       bits 8 to 14 run UP column 8 from the bottom. */
    var bits = formatBits(maskIndex), size = m.length, i;
    for (i = 0; i <= 5; i++) m[i][8] = (bits >> i) & 1;
    m[7][8] = (bits >> 6) & 1;
    m[8][8] = (bits >> 7) & 1;
    m[8][7] = (bits >> 8) & 1;
    for (i = 9; i <= 14; i++) m[8][14 - i] = (bits >> i) & 1;
    for (i = 0; i <= 7; i++) m[8][size - 1 - i] = (bits >> i) & 1;
    for (i = 8; i <= 14; i++) m[size - 15 + i][8] = (bits >> i) & 1;
    m[size - 8][8] = 1;
  }

  /* the specification's four penalty rules, used to choose a mask */
  function penalty(m) {
    var n = m.length, score = 0, r, c, i, run, dark = 0;
    for (r = 0; r < n; r++) {
      run = 1;
      for (c = 1; c < n; c++) {
        if (m[r][c] === m[r][c - 1]) { run++; } else { if (run >= 5) score += 3 + (run - 5); run = 1; }
      }
      if (run >= 5) score += 3 + (run - 5);
    }
    for (c = 0; c < n; c++) {
      run = 1;
      for (r = 1; r < n; r++) {
        if (m[r][c] === m[r - 1][c]) { run++; } else { if (run >= 5) score += 3 + (run - 5); run = 1; }
      }
      if (run >= 5) score += 3 + (run - 5);
    }
    for (r = 0; r < n - 1; r++) {
      for (c = 0; c < n - 1; c++) {
        var s = m[r][c] + m[r][c + 1] + m[r + 1][c] + m[r + 1][c + 1];
        if (s === 0 || s === 4) score += 3;
      }
    }
    var pat = [1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0];
    function hasPattern(get) {
      var hits = 0;
      for (var start = 0; start + 11 <= n; start++) {
        var ok = true;
        for (i = 0; i < 11; i++) { if (get(start + i) !== pat[i]) { ok = false; break; } }
        if (ok) hits++;
      }
      return hits;
    }
    for (r = 0; r < n; r++) score += 40 * hasPattern(function (i2) { return m[r][i2]; });
    for (c = 0; c < n; c++) score += 40 * hasPattern(function (i2) { return m[i2][c]; });
    for (r = 0; r < n; r++) for (c = 0; c < n; c++) dark += m[r][c];
    score += 10 * Math.floor(Math.abs((dark * 100) / (n * n) - 50) / 5);
    return score;
  }

  /* ------------------------------------------------------------- api */

  function matrix(text) {
    var bytes = new TextEncoder().encode(text).length;
    var version = 0;
    for (var v = 1; v <= 7; v++) {
      if (bytes + 2 <= VERSIONS[v].data) { version = v; break; }
    }
    /* refused rather than mis-encoded; the caller shows the address instead */
    if (!version) return null;

    var all = codewords(text, version);
    var sk = skeleton(version);
    var base = sk.m;
    placeData(base, all);

    var best = null, bestScore = Infinity;
    for (var mi = 0; mi < 8; mi++) {
      var cand = applyMask(base, sk.free, mi);
      placeFormat(cand, mi);
      var sc = penalty(cand);
      if (sc < bestScore) { bestScore = sc; best = cand; }
    }
    return best;
  }

  /* SVG rather than canvas: crisp at any size, scales with the dialog, and
     needs no pixel ratio handling. quiet is the mandatory 4-module margin;
     without it many readers simply will not see the code. */
  function svg(text, opts) {
    var m = matrix(text);
    if (!m) return null;
    var o = opts || {};
    var quiet = o.quiet == null ? 4 : o.quiet;
    var n = m.length, dim = n + quiet * 2;
    var d = '';
    for (var r = 0; r < n; r++) {
      for (var c = 0; c < n; c++) {
        if (m[r][c]) d += 'M' + (c + quiet) + ' ' + (r + quiet) + 'h1v1h-1z';
      }
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + dim + ' ' + dim + '" '
      + 'width="' + (o.px || 180) + '" height="' + (o.px || 180) + '" role="img" '
      + 'aria-label="' + (o.label || 'QR code') + '" shape-rendering="crispEdges">'
      + '<rect width="' + dim + '" height="' + dim + '" fill="' + (o.bg || '#ffffff') + '"/>'
      + '<path d="' + d + '" fill="' + (o.fg || '#11110f') + '"/></svg>';
  }

  /* _forceMask exists so a decoder can be pointed at every mask in turn.
     If exactly one reads back, the fault is in mask selection; if none do,
     it is upstream in the data or the format bits. That bisects a barcode
     bug in one step instead of by inspection. */
  function _forceMask(text, maskIndex) {
    var bytes = new TextEncoder().encode(text).length, version = 0;
    for (var v = 1; v <= 7; v++) { if (bytes + 2 <= VERSIONS[v].data) { version = v; break; } }
    if (!version) return null;
    var all = codewords(text, version);
    var sk = skeleton(version);
    placeData(sk.m, all);
    var cand = applyMask(sk.m, sk.free, maskIndex);
    placeFormat(cand, maskIndex);
    return cand;
  }

  window.ccQR = {
    matrix: matrix, svg: svg, _forceMask: _forceMask,
    _encodeBytes: encodeBytes, _rsEncode: rsEncode,
    capacityBytes: VERSIONS[7].data - 2,
  };
}());
